import { DEFAULT_CHART_OPTIONS, normalizeChartOptions } from 'utils/charts/chartStyle.utils';
import { DEFAULT_DISPLAY_THEME, normalizeDisplayTheme } from 'utils/themes/theme.utils';
import { DEFAULT_ACCESSIBILITY_OPTIONS } from 'store/config/displayOptions.config';
import { normalizeAccessibilityOptions } from 'store/utils/displayOptions.utils';
import { DEFAULT_MAP_OPTIONS, normalizeMapOptions } from 'utils/maps/mapTile.utils';

export const FUSION_FRONTEND_OPTIONS_KEY = 'fusionFrontend';
export const FUSION_FRONTEND_OPTIONS_VERSION = 1;

const isPlainObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

export const normalizeDisplayOptionsForProfile = (displayOptions = {}) => ({
  displayTheme: normalizeDisplayTheme(displayOptions.displayTheme || DEFAULT_DISPLAY_THEME),
  mapOptions: normalizeMapOptions(displayOptions.mapOptions || DEFAULT_MAP_OPTIONS),
  chartOptions: normalizeChartOptions(displayOptions.chartOptions || DEFAULT_CHART_OPTIONS),
  accessibilityOptions: normalizeAccessibilityOptions(
    displayOptions.accessibilityOptions || DEFAULT_ACCESSIBILITY_OPTIONS,
  ),
});

export const getProfileDisplayOptions = (profileOptions) => {
  if (!isPlainObject(profileOptions)) return null;

  const frontendOptions = profileOptions[FUSION_FRONTEND_OPTIONS_KEY];
  if (!isPlainObject(frontendOptions) || !isPlainObject(frontendOptions.displayOptions)) {
    return null;
  }

  return normalizeDisplayOptionsForProfile(frontendOptions.displayOptions);
};

export const mergeProfileDisplayOptions = (profileOptions, displayOptions) => {
  const safeProfileOptions = isPlainObject(profileOptions) ? profileOptions : {};
  const existingFrontendOptions = isPlainObject(safeProfileOptions[FUSION_FRONTEND_OPTIONS_KEY])
    ? safeProfileOptions[FUSION_FRONTEND_OPTIONS_KEY]
    : {};

  return {
    ...safeProfileOptions,
    [FUSION_FRONTEND_OPTIONS_KEY]: {
      ...existingFrontendOptions,
      version: FUSION_FRONTEND_OPTIONS_VERSION,
      displayOptions: normalizeDisplayOptionsForProfile(displayOptions),
    },
  };
};
